import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-az-edit-speakers',
  templateUrl: './az-edit-speakers.component.html',
  styleUrls: ['./az-edit-speakers.component.scss']
})
export class AzEditSpeakersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
